;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "Pay",
  props: ["callback_url", "request_type", "gateway_name"],
  data: function data() {
    return {
      currency: null,
      logo: null,
      invoice_amount: null,
      agent_fee: 0,
      fee: 0,
      invoice_number: null,
      url: null,
      total_amount: 0,
      payment_instructions: null,
      div_id: null,
      content_div: null
    };
  },

  created: function created() {
    var id = this.$attrs["gid"];
    this.div_id = "pesaflowInstructionModal" + id;
    this.content_div = "contentDiv" + id;
  },
  mounted: function mounted() {
    var _this = this;

    this.invoice_number = this.$attrs["invoice_no"];
    this.invoice_amount = this.$attrs["amount_net"];
    this.currency = this.$attrs["currency"];
    this.fee = this.$attrs["fee"];
    this.agent_fee = this.$attrs["agent_fee"];
    this.url = this.$attrs["status_api_url"];
    this.logo = this.$attrs["logo"];
    this.payment_instructions = this.$attrs["instructions"];
    this.set_total_amount();

    this.write_instructions(this.content_div, this.payment_instructions);
    $("#" + this.div_id).on("hidden.bs.modal", function () {
      _this.destroyTimer();
    });
  },
  methods: {
    destroyTimer: function destroyTimer() {
      this.$refs.timer.destroyTimer();
    },
    write_instructions: function write_instructions(div, instructions) {
      $("#" + this.content_div).html(instructions);
    },

    set_total_amount: function set_total_amount() {
      if (this.$attrs["invoice_amount"]) {
        this.total_amount = parseFloat(this.$attrs["invoice_amount"]);
      } else {
        this.total_amount = Math.ceil(parseFloat(this.invoice_amount) + parseFloat(this.fee) + parseFloat(this.agent_fee));
      }
    },
    downloadInstructions: function downloadInstructions() {
      var doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a5" });
      doc.fromHTML($("#" + this.content_div).html(), 15, 15, {
        width: 170
      });
      doc.save(this.gateway_name + " Payment Instructions.pdf");
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":_vm.div_id,"tabindex":"-1","role":"dialog","aria-labelledby":"pesaflowInstructionModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-full",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body d-flex align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 mx-auto"},[_c('img',{staticClass:"navbar-brand-img",attrs:{"src":_vm.logo,"alt":"..."}}),_vm._v(" "),_c('div',{staticClass:"card mt-3"},[_c('invoice-summary',{attrs:{"invoice":_vm.invoice,"gateway_name":"","currency":_vm.currency,"online_convenience_fee":_vm.fee,"total_amount":_vm.total_amount,"amount_net":_vm.invoice_amount}}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('a',{staticClass:"btn btn-link text-blue mt-3",attrs:{"href":"#"},on:{"click":_vm.downloadInstructions}},[_c('h3',[_vm._v("Download Payment Instructions")])])]),_vm._v(" "),_c('div',{staticClass:"card-body",attrs:{"id":_vm.content_div}}),_vm._v(" "),_c('div',{staticClass:"card-footer d-flex justify-content-end align-items-center"},[_c('a',{staticClass:"btn btn-link text-dark px-5",attrs:{"href":"#","data-dismiss":"modal"},on:{"click":_vm.destroyTimer}},[_vm._v("Cancel")]),_vm._v(" "),_c('complete-button',{ref:"timer",attrs:{"gateway":"pesaflow-internal","status_api_url":_vm.url,"invoice_no":_vm.invoice_number,"callback_url":_vm.callback_url}})],1)],1)])])])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header d-flex align-items-center"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{staticClass:"fe fe-x text-dark",attrs:{"aria-hidden":"true"}})])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4258785d", __vue__options__)
  } else {
    hotAPI.reload("data-v-4258785d", __vue__options__)
  }
})()}